export default (autoPlay = false) => ({
    isPlaying: autoPlay,
    isEnded: false,
    isMuted: autoPlay,

    toggle() {
        const video = this.$refs.video

        if (!video.paused) {
            video.pause()
        } else {
            video.play()
        }
    },

    toggleAudio() {
        this.$refs.video.muted = !this.$refs.video.muted
    },

    init() {
        const video = this.$refs.video

        video.addEventListener('play', () => (this.isPlaying = true))
        video.addEventListener('pause', () => (this.isPlaying = false))
        video.addEventListener(
            'volumechange',
            () => (this.isMuted = video.muted)
        )
        this.$watch('isPlaying', () => (this.isEnded = video.ended))
    },
})
